module.exports = __webpack_public_path__ + "img/br.bc0bde8e.svg";